import ConfirmAPI from 'utils/api/ConfirmAPI';
import { getFriendlyErrorMessageIfErrorOccurred } from 'utils/util/util';
import {
  CalibrationComment,
  CreateCalibrationCommentPayload,
  UpdateCalibrationCommentPayload,
} from '../types';

type ProxyParameters = {
  proxy: string | undefined;
  organization_id: number | undefined;
  organization: number | undefined;
};

export const calibrationViewsApi = {
  /**
   * Delete a calibration view
   */
  delete: (
    id: string,
    proxyParameters: ProxyParameters,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    ConfirmAPI.sendRequestToConfirm(
      'DELETE',
      `/calibration-views/${id}`,
      proxyParameters,
      (_data, error: unknown, hardErrorMessage: unknown) => {
        if (error) {
          const friendlyError = getFriendlyErrorMessageIfErrorOccurred(
            error,
            hardErrorMessage
          );
          console.error('Failed to delete calibration view:', friendlyError);
          if (onError) {
            onError(friendlyError);
          }
          return;
        }

        if (onSuccess) {
          onSuccess();
        }
      }
    );
  },

  /**
   * Create a calibration comment
   */
  createComment: (
    proxyParameters: ProxyParameters,
    payload: CreateCalibrationCommentPayload,
    onSuccess?: (comment: CalibrationComment) => void,
    onError?: (error: any) => void
  ) => {
    ConfirmAPI.sendRequestToConfirm(
      'POST',
      '/calibration-comments',
      { ...proxyParameters, ...payload },
      (data, error: unknown, hardErrorMessage: unknown) => {
        if (error) {
          const friendlyError = getFriendlyErrorMessageIfErrorOccurred(
            error,
            hardErrorMessage
          );
          console.error('Failed to create calibration comment:', friendlyError);
          if (onError) {
            onError(friendlyError);
          }
          return;
        }

        if (onSuccess) {
          onSuccess(data);
        }
      }
    );
  },

  /**
   * Delete a calibration comment
   */
  deleteComment: (
    commentId: number,
    proxyParameters: ProxyParameters,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    ConfirmAPI.sendRequestToConfirm(
      'DELETE',
      `/calibration-comments/${commentId}`,
      proxyParameters,
      (_data, error: unknown, hardErrorMessage: unknown) => {
        if (error) {
          const friendlyError = getFriendlyErrorMessageIfErrorOccurred(
            error,
            hardErrorMessage
          );
          console.error('Failed to delete calibration comment:', friendlyError);
          if (onError) {
            onError(friendlyError);
          }
          return;
        }

        if (onSuccess) {
          onSuccess();
        }
      }
    );
  },

  /**
   * Update a calibration comment's text, recommendation and/or visibility
   */
  updateComment: (
    commentId: number,
    calibrationViewId: number,
    payload: UpdateCalibrationCommentPayload,
    proxyParameters: ProxyParameters,
    onSuccess?: (comment: CalibrationComment) => void,
    onError?: (error: any) => void
  ) => {
    ConfirmAPI.sendRequestToConfirm(
      'PATCH',
      `/calibration-comments/${commentId}`,
      {
        ...proxyParameters,
        ...payload,
        calibration_view_id: calibrationViewId,
      },
      (data, error: unknown, hardErrorMessage: unknown) => {
        if (error) {
          const friendlyError = getFriendlyErrorMessageIfErrorOccurred(
            error,
            hardErrorMessage
          );
          console.error('Failed to update calibration comment:', friendlyError);
          if (onError) {
            onError(friendlyError);
          }
          return;
        }

        if (onSuccess) {
          onSuccess(data);
        }
      }
    );
  },
};
